<template>
  <mdb-container class="mt-5" id="contactkey">
    <mdb-card>
      <mdb-card-title class="mt-4 h2">{{ title }}</mdb-card-title>
      <mdb-card-body>
        <mdb-card-text
          class="pr-5 pl-5"
          mr-4
          ml-4
        >{{ untertitel }}
</mdb-card-text>
        <form class="needs-validation" novalidate @submit.prevent="submitForm">
          <mdb-row>
            <mdb-col md="8">
              <mdb-row>
                <mdb-col>
                  <mdb-input label="Name" v-model="fields.name" required />
                </mdb-col>
                <mdb-col>
                  <mdb-input type="email" label="E-Mail" v-model="fields.email" required />
                </mdb-col>
              </mdb-row>
              <mdb-row>
                <mdb-col>
                  <mdb-input label="Betreff" v-model="fields.subject" required />
                </mdb-col>
              </mdb-row>
              <mdb-row>
                <mdb-col>
                  <mdb-input
                    type="textarea"
                    label="Nachricht"
                    v-model="fields.message"
                    required
                  />
                </mdb-col>
              </mdb-row>
            </mdb-col>
            <mdb-col md="4">
              <mdb-row>
                <mdb-col class="mt-4">
                  <mdb-icon icon="map-marker-alt" size="2x" />
                  <p>3441 21st Ave. SW</p>
                </mdb-col>
              </mdb-row>
              <mdb-row>
                <mdb-col class="mt-4">
                  <mdb-icon icon="phone" size="2x" />
                  <p>Tel. 001-305-505-2052</p>
                </mdb-col>
              </mdb-row>
              <mdb-row>
                <mdb-col class="mt-4">
                  <mdb-icon icon="envelope" size="2x" />
                  <p>info@amclass-autotransport.com</p>
                </mdb-col>
              </mdb-row>
            </mdb-col>
          </mdb-row>
          <mdb-btn color="primary" type="submit" class="float-left">Send</mdb-btn>
        </form>
      </mdb-card-body>
    </mdb-card>
  </mdb-container>
</template>
<style lang="scss" scoped>
  .container {
    text-align: center;
  }
  h2, i {
    color: #2196f3;
  }
  .card {
    background-color: rgba(0, 0, 0, 0);
  }
</style>
<script>
  import axios from "axios";

  import {
    mdbContainer,
    mdbInput,
    mdbCard,
    mdbCardHeader,
    mdbCardTitle,
    mdbCardText,
    mdbCardBody,
    mdbIcon,
    mdbBtn,
    mdbRow,
    mdbCol
  } from "mdbvue";

  export default {
    components: {
      mdbContainer,
      mdbInput,
      mdbCard,
      mdbCardHeader,
      mdbCardTitle,
      mdbCardBody,
      mdbCardText,
      mdbIcon,
      mdbBtn,
      mdbRow,
      mdbCol
    },
    props: {
      title: String,
      untertitel: String,
    },
    data() {
      return {
        fields: {
          name: "",
          email: "",
          subject: "",
          message: "",
          token: "sdgfh6LcUV34UAAAAAN-bMzAA944UA3X8I3Nc"
        }
      };
    },
    methods: {
      validate() {
        const form = [...arguments];
        const emailRegexp = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
        for (let index in form) {
          let field = form[index];
          if (field === "email" && !emailRegexp.test(this.fields[field])) {
            return false;
          } else if (this.fields[field] === "") {
            return false;
          }
        }
        return true;
      },
      submitForm(event) {
        event.target.classList.add("was-validated");
        console.log(this.fields);
        if (this.validate("email", "name", "message", "subject")) {
          const headers = {
            'Content-Type': 'application/json',
          }

          axios
            .post("https://us-central1-coapi-ec5a3.cloudfunctions.net/form", this.fields, {
              headers: headers
            })
            .then(response => {
              alert("Message sent!");
              this.fields = {};
              event.target.classList.remove("was-validated");
            })
            .catch(error => {
              console.log(error);
            });
        }
      }
    }
  };
</script>
/*
  import axios from 'axios';
  import { mdbContainer, mdbRow, mdbCol, mdbBtn, mdbIcon, mdbInput, mdbTextarea, mdbCard, mdbCardBody } from 'mdbvue';
  export default {
    name: 'ContactPage',
    data() {
      return {
        name: '',
        email: '',
        subject: '',
        message: ''
      }
    },
    components: {
      mdbContainer,
      mdbRow,
      mdbCol,
      mdbBtn,
      mdbIcon,
      mdbInput,
      mdbTextarea,
      mdbCard,
      mdbCardBody
    },
    methods: {
      onSubmit: function (event) {
        const url = "https://us-central1-coapi-ec5a3.cloudfunctions.net/form";

        axios({
          method: 'post',
          url: url,
          data: {
            name: this.name,
            email: this.email,
            subject: this.subject,
            message: this.message
          },
          headers: {
            'Content-Type': 'application/json'
          },
          crossdomain: true
        }).then(response => (alert("Response " + response))).catch(error => {
          alert("Error" + this.name);
          console.log(error);
        });
      }
    }
  } 
</script> */